// extracted by css-extract-rspack-plugin
export default {"dialogActions":"JGkIvwPL4QIBsWBg","dialogBody":"LMELAAP8Sg8QG2Ow","emptyState":"StlSzAbv1O0UfTlA","loading":"MYl6Q0WHDPsotkIg"};